
import { useNavigate } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import { Card, CardHeader, CardContent, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const PendingApprovalMessage = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className="bg-omoduduwa-indigo text-white py-12">
        <div className="container-custom">
          <h1 className="text-3xl md:text-4xl font-bold mb-2 text-white">
            Ọmọ Odùduwà Community
          </h1>
          <p className="text-lg text-white max-w-2xl">
            Your access is pending approval
          </p>
        </div>
      </div>
      
      <div className="container-custom py-12">
        <Card className="max-w-2xl mx-auto bg-white border border-gray-200 shadow-xl">
          <CardHeader>
            <CardTitle className="flex items-center text-gray-900">
              <AlertCircle className="mr-2 text-amber-500" />
              Membership Pending Approval
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="mb-4 text-gray-900 font-medium">
              Your registration is pending. You'll be granted access to the community after approval by an admin.
            </p>
            <p className="mb-4 text-gray-800">
              This process usually takes 1-2 business days. If you have any questions, please contact our support team.
            </p>
            <div className="flex justify-end">
              <Button variant="outline" onClick={() => navigate('/')} className="text-gray-900 border-gray-300 hover:bg-gray-100">
                Return to Home
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PendingApprovalMessage;
